import { reportApiError } from '../herald';

// THE web API client (§5.3). One base URL instead of seventeen copies, the
// auth header attached in one place, and — at last — a shared 401
// interceptor: on an expired access token every call refreshes once through
// the AuthProvider's single-flight refresh and retries, instead of dumping
// the player to login. 403 is "not your campaign" and is never touched here.

export const API_BASE =
  process.env.REACT_APP_API_URL || `${window.location.protocol}//${window.location.hostname}`;

// Wired by AuthProvider on mount; null until then (requests just go out
// with whatever token localStorage holds).
let refreshHandler = null;
let sessionLostHandler = null;

export function registerAuthHandlers({ refresh, onSessionLost }) {
  refreshHandler = refresh || null;
  sessionLostHandler = onSessionLost || null;
}

const AUTH_FREE_PATHS = ['/api/login', '/api/register', '/api/auth/refresh', '/api/auth/logout'];

function buildHeaders(options, token) {
  const headers = { ...(options.headers || {}) };
  const isForm = typeof FormData !== 'undefined' && options.body instanceof FormData;
  if (!isForm && !('Content-Type' in headers) && !('content-type' in headers)) {
    headers['Content-Type'] = 'application/json';
  }
  if (token && !('Authorization' in headers)) {
    headers.Authorization = `Bearer ${token}`;
  }
  return headers;
}

/**
 * Drop-in fetch for API routes: same Response object back, path-relative.
 *
 *   const res = await apiFetch('/api/user/campaigns', { method: 'POST' });
 */
export async function apiFetch(path, options = {}) {
  const method = options.method || 'GET';
  const attempt = async (token) => {
    try {
      return await fetch(`${API_BASE}${path}`, { ...options, headers: buildHeaders(options, token) });
    } catch (err) {
      reportApiError(method, path, 0); // network failure
      throw err;
    }
  };

  let res = await attempt(localStorage.getItem('token'));

  const authFree = AUTH_FREE_PATHS.some((p) => path.startsWith(p));
  if (res.status === 401 && !authFree && refreshHandler) {
    const freshToken = await refreshHandler(); // single-flight in AuthProvider
    if (freshToken) {
      res = await attempt(freshToken);
    }
    if (res.status === 401) {
      sessionLostHandler?.();
    }
  }
  if (!res.ok) reportApiError(method, path, res.status);
  return res;
}
